import {Injectable} from '@angular/core';
import {HttpEvent, HttpHandler, HttpInterceptor, HttpParams, HttpRequest,} from '@angular/common/http';
import {Observable} from 'rxjs';
import {ClassroomState, ClassroomStateModel} from '@app/state/classroom-state.service';
import {Store} from '@ngxs/store';

@Injectable({
  providedIn: 'root'
})
export class InterceptorService implements HttpInterceptor {

  private room: ClassroomStateModel;

  constructor(private store: Store) {
    this.listenStoreChanges();
  }

  // Add roomNum as a path prefix for server routing (to be truncated), and as a request param for webapp
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Cross-origin reqs
    if (req.url.match(/^http:|https:/) && !req.url.startsWith(window.location.origin)) {
      return next.handle(req);
    }
    // Same-origin reqs
    else {
      const newReq: HttpRequest<any> = req.clone({
        url: `/${this.room.roomNum}${req.url}`,
        params: (req.params || new HttpParams())
          .set('roomNum', this.room.roomNum)
      });
      return next.handle(newReq);
    }
  }

  private listenStoreChanges(): void {
    this.store.select(ClassroomState).subscribe((classroom: ClassroomStateModel) => {
      this.room = classroom;
    });
  }
}
